import { deriveMarkerIcon } from './icons';
import { IMarker, IMarkerInput, MarkerTypes } from './types';

export const checkSingleUseMarker = (type: MarkerTypes): boolean =>
  [MarkerTypes.User, MarkerTypes.UserManual, MarkerTypes.Driver, MarkerTypes.Destination].includes(
    type
  );

// this is just for mobile apps as after some research most of the performance issues was caused by SVG images
export const getKeyForMarkerInput = (
  { type, location }: IMarkerInput,
  isSingleUseMarker: boolean
): string => (isSingleUseMarker ? type : `${location.lat}${location.lng}`);

export const generateMarker = ({ id, type, location, onPress }: IMarkerInput): IMarker => {
  const isSingleUseMarker = checkSingleUseMarker(type);
  return {
    id,
    location,
    icon: deriveMarkerIcon(type),
    onPress,
    type,
    preventMarkerPress: isSingleUseMarker,
    visible: type !== MarkerTypes.UserManual,
  };
};
